import Disclaimer from 'components/Page/Disclaimer/Disclaimer';

export default Disclaimer;
